<style lang="less" scoped>
.query-title-div {
  width: 110px !important;
}

.lang-width {
  width: 450px !important;
}

.margin-tb {
  height: 32px;
  margin-top: 4px;
}

.notice-main-title-div {
  font-size: 18px;
  font-weight: 600;
  margin-bottom: 16px;
  justify-content: space-between;
}

.query-flex-btns-div {
  display: flex;
  justify-content: flex-end;
}

.eye {
  display: flex;
  justify-content: center;
  align-items: center;
  position: relative;

  img {
    width: 20px;
    height: 20px;
    position: absolute;
    top: 0;
    right: 20%;
  }
}
</style>

<template>
  <div class="list-container">
    <div class="list-bread-crumb-div">
      <ZD-bread-crumb :bConfigList="pageConfig.listBreadCrumb"></ZD-bread-crumb>
    </div>
    <div class="list-content-div">
      <div class="list-header-title-div">家充无忧套餐包</div>
      <div class="page-action-btns flex margin-tb-10">
        <div class="flex-grow-1"></div>
        <button
          class="common-bg-button"
          @click="addPackage()"
        >
          创建
        </button>
        <button
          class="common-bg-button"
          @click="toEditOrder()"
        >
          编辑/查看
        </button>
        <button
          class="common-bg-button"
          v-if="0"
          @click="
            () => {
              showMultiQuerys = !showMultiQuerys;
            }
          "
        >
          高级筛选
        </button>
      </div>
      <!-- 高级筛选 -->
      <div
        class="multi-query-div el-fade-in-linear"
        v-if="showMultiQuerys"
      >
        <div class="margin-bottom-16">
          <el-row :gutter="20">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">关键字搜索</p>
              <el-input
                clearable
                v-model="queryInfo.keyWord"
                size="small"
                placeholder="请输入订单编号/用户手机/用户姓名/支付流水号"
              />
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">退款方式</p>
              <el-select
                v-model="queryInfo.refundWay"
                size="small"
                clearable
                class="full-width"
                placeholder="请选择退款方式"
              >
                <el-option
                  label="商家代扣"
                  value="AGREEMENT"
                />
                <el-option
                  label="手动退款"
                  value="MANUAL"
                />
                <el-option
                  label="芝麻免押"
                  value="FREE"
                />
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">退款原因</p>
              <el-select
                v-model="queryInfo.refundReason"
                size="small"
                clearable
                class="full-width"
                placeholder="请选择退款原因"
              >
                <el-option
                  label="平台测算"
                  value="平台测算"
                />
                <el-option
                  label="用户申请"
                  value="用户申请"
                />
                <el-option
                  label="其他"
                  value="其他"
                />
              </el-select>
            </el-col>
          </el-row>
          <el-row :gutter="20">
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">退款类型</p>
              <el-select
                v-model="queryInfo.refundType"
                size="small"
                clearable
                class="full-width"
                placeholder="请选择退款类型"
              >
                <el-option
                  label="全额退款"
                  value="ALL"
                />
                <el-option
                  label="部分退款"
                  value="PART"
                />
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">订单类型</p>
              <el-select
                v-model="queryInfo.orderType"
                size="small"
                clearable
                class="full-width"
                placeholder="请选择订单类型"
              >
                <el-option
                  label="正常充电订单"
                  value="COMMON_CHARGE_ORDER"
                />
                <el-option
                  label="私桩共享订单"
                  value="SHARE_CHARGE_ORDER"
                />
                <el-option
                  label="服务费违约订单"
                  value="SERVICE_DEFAULT_FEE"
                />
                <el-option
                  label="商品订单"
                  value="ZM_ORDER"
                />
              </el-select>
            </el-col>
            <el-col
              :span="8"
              v-if="0"
            >
              <p class="margin-bottom-5 font-14">购买名称</p>
              <el-select
                v-model="queryInfo.purchaseName"
                size="small"
                clearable
                class="full-width"
                placeholder="请选择订单类型"
              >
                <el-option
                  label="支付成功"
                  value="PAID_SUCCESS"
                />
                <el-option
                  label="支付失败"
                  value="PAID_FAIL"
                />
              </el-select>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">退款结果</p>
              <el-select
                v-model="queryInfo.refundResult"
                size="small"
                clearable
                class="full-width"
                placeholder="请选择退款结果"
              >
                <el-option
                  label="退款成功"
                  value="Y"
                />
                <el-option
                  label="退款失败"
                  value="N"
                />
              </el-select>
            </el-col>
          </el-row>
          <el-row
            :gutter="20"
            class="margin-top-10"
          >
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">订单创建/购买时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.createFromTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择开始时间"
                  class="flex-1"
                />
                <span
                  class="time-query-line"
                  style="line-height: 32px"
                  >-</span
                >
                <el-date-picker
                  v-model="queryInfo.createToTime"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择结束时间"
                  class="flex-1"
                />
              </div>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">退款操作时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.refundOperateTimeBegin"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择开始时间"
                  class="flex-1"
                />
                <span
                  class="time-query-line"
                  style="line-height: 32px"
                  >-</span
                >
                <el-date-picker
                  v-model="queryInfo.refundOperateTimeEnd"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择结束时间"
                  class="flex-1"
                />
              </div>
            </el-col>
            <el-col :span="8">
              <p class="margin-bottom-5 font-14">退款完成时间</p>
              <div class="flex-r">
                <el-date-picker
                  v-model="queryInfo.refundFinishTimeBegin"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择开始时间"
                  class="flex-1"
                />
                <span
                  class="time-query-line"
                  style="line-height: 32px"
                  >-</span
                >
                <el-date-picker
                  v-model="queryInfo.refundFinishTimeEnd"
                  type="datetime"
                  size="small"
                  prefix-icon="el-icon-date"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择结束时间"
                  class="flex-1"
                />
              </div>
            </el-col>
          </el-row>
        </div>
        <div class="query-flex-btns-div margin-bottom-16">
          <button
            class="common-bg-button"
            @click="getListData(pagination, true)"
          >
            搜 索
          </button>
          <button
            class="common-bg-button"
            @click="resetQuery()"
          >
            重 置
          </button>
        </div>
      </div>

      <!-- 表格 -->
      <div class="list-table">
        <el-table
          :data="tableData"
          style="width: 100%"
          border
          stripe
          @selection-change="
            (sels) => {
              selections = sels;
            }
          "
        >
          <el-table-column
            type="selection"
            width="40"
            align="center"
          />
          <el-table-column
            prop="serviceActivityId"
            label="服务套餐ID"
            align="center"
          >
            <template slot-scope="scope">
              <el-link
                type="primary"
                @click="goDetailByOne(scope.row)"
              >
                {{ scope.row.serviceActivityId }}</el-link
              >
            </template>
          </el-table-column>

          <el-table-column
            prop="payContent"
            label="购买名称"
            align="center"
          >
            <template slot-scope="scope">
              家充无忧服务{{ scope.row.payContent }}米
            </template>
          </el-table-column>

          <el-table-column
            prop="enableStatus"
            label="启用状态"
            align="center"
          >
            <template slot-scope="scope">
              <el-tag
                type="success"
                v-if="scope.row.enableStatus == 0"
                >启用</el-tag
              >
              <el-tag
                type="danger"
                v-else
                >禁用</el-tag
              >
            </template>
          </el-table-column>

          <el-table-column
            prop="expirationStatus"
            label="有效期状态"
            align="center"
          />
          <el-table-column
            prop="installedMeters"
            label="安装米数(米)"
            align="center"
          >
            <template slot-scope="scope"
              >{{ scope.row.installedMeters }}米内</template
            >
          </el-table-column>
          <el-table-column
            prop="serviceFeePrice"
            label="服务费价格（元）"
            align="center"
          />
          <el-table-column
            prop="startExpirationDate"
            label="有效期生效时间"
            align="center"
          />
          <el-table-column
            prop="endExpirationDate"
            label="有效期截止时间"
            align="center"
          />
          <el-table-column
            prop="createdByName"
            label="创建人"
            align="center"
          />
          <el-table-column
            prop="createdWhen"
            label="创建时间"
            align="center"
          />
          <el-table-column
            prop="lastModifiedByName"
            label="更新人"
            align="center"
          />
          <el-table-column
            prop="lastModifiedWhen"
            label="更新时间"
            align="center"
          />
          <el-table-column
            prop="remark"
            label="备注"
            width="320"
            align="center"
          >
            <template slot-scope="scope">
              <el-popover
                placement="top-start"
                width="320"
                trigger="hover"
              >
                <div>{{ scope.row.remark }}</div>
                <span
                  slot="reference"
                  v-if="scope.row.remark.length > 20"
                  >{{
                    scope.row.remark.substr(0, 20) + "..."
                  }}</span
                >
                <span
                  slot="reference"
                  v-else
                  >{{ scope.row.remark }}</span
                >
              </el-popover>
            </template>
          </el-table-column>
          <el-table-column
            label="操作"
            fixed="right"
            align="center"
          >
            <template slot-scope="scope">
              <el-button
                v-if="scope.row.enableStatus == 1"
                @click="setStatus(scope.row, 0)"
                type="text"
                size="small"
                >启用</el-button
              >
              <el-button
                v-if="scope.row.enableStatus == 0"
                type="text"
                size="small"
                @click="setStatus(scope.row, 1)"
                >停用</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页 -->
      <div class="list-pagination">
        <ZD-pagination
          :pagination="pagination"
          v-on:pageUpdate="getListData"
        />
      </div>
    </div>

    <!-- 退款编辑 -->
    <el-dialog
      title="退款编辑"
      width="520px"
      :visible.sync="showRtOrderDialog"
    >
      <el-form
        :model="rtOrderFormInfo"
        ref="userRfForm"
        :rules="rtOrderFormRules"
      >
        <el-form-item
          label="退款流水号"
          prop="transactionNo"
        >
          <el-input
            clearable
            v-model="rtOrderFormInfo.transactionNo"
            size="small"
          ></el-input>
        </el-form-item>
      </el-form>
      <div
        slot="footer"
        class="dialog-footer"
      >
        <el-button
          type="primary"
          @click="submitRtOrderForm('userRfForm')"
          size="small"
          >提 交</el-button
        >
        <el-button
          @click="showRtOrderDialog = false"
          size="small"
          >取 消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import pageConfig from "./page-config";
export default {
  data() {
    return {
      isFlag: false,
      tableData: [], // 表格数据
      pageConfig: pageConfig, // 页面配置
      pagination: pageConfig.pagination,
      queryInfo: {}, //初始化数据
      showMultiQuerys: false,
      orderStatusList: [],

      showRtOrderDialog: false,
      rtOrderFormInfo: {},
      rtOrderFormRules: {},
      selections: [],
    };
  },
  methods: {
    checkSelectOne(selections) {
      if (selections.length < 1) {
        this.$U.error("请选择需要操作的对象");
        return false;
      }
      if (selections.length > 1) {
        this.$U.error("只能选择一个操作的对象");
        return false;
      }
      return true;
    },
    // 活动订单编辑
    toEditOrder() {
      if (this.checkSelectOne(this.selections)) {
        const editInfo = this.selections[0];
        this.$router.push({
          name: "packageZreoListDetail",
          query: {
            edit: 1,
            serviceActivityId: editInfo.serviceActivityId,
          },
        });
      }
    },
    setStatus(row, status) {
      let _ = this;
      _.$U.showLoading(_);
      row.enableStatus = status;
      _.$H.post(_, _.$A.activityOrder.editPackage, row).then((res) => {
        _.getListData(_.pagination, true);
        _.$U.hideLoading(_);
      });
    },
    goDetailByOne(row) {
      // this.$store.commit("setEditObj", row);
      this.$router.push({
        name: "packageZreoListDetail",
        query: {
          edit: 1,
          serviceActivityId: row.serviceActivityId,
        },
      });
    },
    addPackage() {
      this.$router.push({
        name: "packageZreoListDetail",
        query: {
          edit: 0,
        },
      });
    },
    flagChange() {
      this.isFlag = !this.isFlag;
    },
    // 获取表格数据
    getListData(pagination, reload = false) {
      let _ = this;
      _.$U.showLoading(_);

      _.queryInfo.pageNum = pagination.current - 1;
      if (reload) {
        _.pagination.current = 0;
        _.queryInfo.pageNum = 0;
      }
      _.queryInfo.pageSize = pagination.pageSize;
      _.queryInfo.corpNo = _.$store.state.corpNo;
      _.$H.post(_, _.$A.activityOrder.packageList, _.queryInfo).then((res) => {
        _.tableData = res.data.data.content || [];
        _.pagination.total = res.data.data.totalElements || 0;
        _.$U.hideLoading(_);
      });
    },
    // 导出
    toExportList() {
      let _ = this;
      _.$U.showLoading(_);
      let urls = "";
      const host = window.location.hostname;
      if (host.includes("shzhida.com")) {
        urls = "http://ocharge.shzhida.com:6777";
      } else {
        urls = "http://192.168.8.174:7997";
      }
      // if (process.env.NODE_ENV == 'development') {
      //   urls = 'http://192.168.8.174:7997'
      // } else {
      //   urls = 'http://ocharge.shzhida.com:6777'
      // }
      _.$H
        .post(_, _.$A.activityOrder.refundOrderListExcel, _.queryInfo)
        .then((res) => {
          _.$U.saveExcelFile(res.data.data);
          var downUrl = urls + res.data.data.filePath;
          window.open(downUrl, "_blank");
          _.$U.hideLoading(_);
        });
    },
    // 重置
    resetQuery() {
      this.queryInfo = {
        keyWord: undefined, // 关键字
        refundWay: undefined, // 退款方式
        refundReason: undefined, // 退款原因
        refundType: undefined, // 退款类型
        orderType: undefined, // 订单类型
        refundResult: undefined, // 退款结果
        refundOperateTimeBegin: undefined, // 退款操作时间
        refundOperateTimeEnd: undefined, // 退款操作时间
        refundFinishTimeBegin: undefined, // 退款操作时间
        refundFinishTimeEnd: undefined, // 退款操作时间
        createFromTime: undefined, // 订单创建/购买时间
        createToTime: undefined, // 订单创建/购买时间
      };
      this.getListData(this.pagination, true);
    },
  },
  mounted() {
    this.getListData(this.pagination, true);
  },
};
</script>
